import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Config from "conFig.js";
const BCTuyencodinhtable = React.memo(function BCTuyencodinhtable(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [sotuyen_noitinh, setSotuyen_noitinh] = React.useState(0);
  const [sotuyen_lientinh, setSotuyen_lientinh] = React.useState(0);
  const [sophuongtien_noitinh, setSophuongtien_noitinh] = React.useState(0);
  const [sophuongtien_lientinh, setSophuongtien_lientinh] = React.useState(0);
  const [sochuyen_noitinh, setSochuyen_noitinh] = React.useState(0);
  const [sochuyen_lientinh, setSochuyen_lientinh] = React.useState(0);
  const [tylethuchien_noitinh, setTylethuchien_noitinh] = React.useState(0);
  const [tylethuchien_lientinh, setTylethuchien_lientinh] = React.useState(0);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Phuongtien/bcslthtuyencodinh?thang=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setSotuyen_noitinh(data[0].sotuyen_noitinh);
            setSotuyen_lientinh(data[0].sotuyen_lientinh);
            setSophuongtien_noitinh(data[0].sophuongtien_noitinh);
            setSophuongtien_lientinh(data[0].sophuongtien_lientinh);
            setSochuyen_noitinh(data[0].sochuyenxethuchien_noitinh);
            setSochuyen_lientinh(data[0].sochuyenxethuchien_lientinh);
            setTylethuchien_noitinh(data[0].tylethuchien_noitinh);
            setTylethuchien_lientinh(data[0].tylethuchien_lientinh);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đon vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Số tuyến tham gia khai thác</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>
            {sotuyen_noitinh + sotuyen_lientinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{sotuyen_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{sotuyen_lientinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>Số lượng phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>
            {sophuongtien_noitinh + sophuongtien_lientinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sophuongtien_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sophuongtien_lientinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Tổng số chuyến xe thực hiện</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>
            {sochuyen_noitinh + sochuyen_lientinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyen_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>Tỷ lệ thực hiện/kế hoạch</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>{tylethuchien_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyen_lientinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>Tỷ lệ thực hiện/kế hoạch</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>{tylethuchien_lientinh}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table} style={{ height: "350px" }}>
      <table id="baocaoxetuyencodinh" className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCTuyencodinhtable.propTypes = {
  thangnam: PropTypes.object,
};
export default BCTuyencodinhtable;
